import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

const EMPTY_RELATED_ADS = []

/**
 * @implements UseCase
 */
export class GetRelatedSubscriptionAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} params
   * @param {Config} params.config
   * @param {GetRelatedAdsService} params.service
   * @param {RelatedAdsRequestValueObjectMapper} params.requestValueObjectMapper
   */
  constructor({config, service, requestValueObjectMapper}) {
    super()

    this._config = config
    this._service = service
    this._defaultCount = this._config.get('search').DEFAULT_RELATED_ADS_COUNT
    this._requestValueObjectMapper = requestValueObjectMapper
  }

  /**
   * Returns the related ads to an specific ad id
   * @return {Promise<AdsListValueObjectLegacy, Error>}
   */
  @tracer({metric: 'GetRelatedSubscriptionAdsUseCase#execute'})
  @inlineError
  async execute({modelId, count = this._defaultCount, context} = {}) {
    const requestVO = this._requestValueObjectMapper.map({
      modelId,
      count,
      context
    })

    if (!requestVO.isValid()) return Promise.resolve(EMPTY_RELATED_ADS)

    const [error, adsListVO] = await this._service.execute(requestVO)

    if (error) {
      return Promise.reject(error)
    }

    return adsListVO && adsListVO.toJSON()
  }
}
